import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { formatDate, fromISO8601_DATE } from "../../../utils/iso8601";
import type { FollowUpSchemaType } from "../reducer/schema";

export function useFollowUpScheduleText(
  schedule: FollowUpSchemaType["schedule"],
  moment: { title: string },
): string {
  const { t } = useTranslation();

  return useMemo(() => {
    switch (schedule.type) {
      case "immediate":
        return t("This Follow-Up will send as soon as you press “Publish”");
      case "specific":
        return t("This Follow-Up will send on {{date}} at {{time}} ({{timezone}})", {
          date: schedule.date ? formatDate(fromISO8601_DATE(schedule.date)) : "",
          time: schedule.time,
          timezone: schedule.timezone ? schedule.timezone : "Recipient's local time",
        });
      case "scheduled":
        return t(
          `Follow-Up will send {{amount}} {{period}} after "{{momentTitle}}" at {{time}} {{timezone}}.` +
            "{{weekendNote}}",
          {
            amount: schedule.amount,
            period: schedule.period,
            momentTitle: moment.title,
            time: schedule.time,
            timezone: schedule.timezone ? schedule.timezone : "Recipient's local time",
            weekendNote: schedule.allow_weekends
              ? ""
              : t(" If that lands on a Saturday or Sunday, it will send on the following Monday."),
          },
        );
    }
  }, [schedule, t, moment.title]);
}
